import { FeaturesHighlight } from "@/libraries/design/patterns/features-highlight/src/features-highlight";
import { RichTextComponent } from "@/libraries/design/utils";

export interface UniformFeaturesHighlightProps {
    title?: string;
    description?: string;
    richText?: string;
    linkText?: string;
    linkHref?: string;
    feature1Eyebrow?: string;
    feature1Title: string;
    feature1Body?: string;
    feature1RichText?: string;
    feature1ImageSrc: string;
    feature1ImageAltText?: string;
    feature2Eyebrow?: string;
    feature2Title: string;
    feature2Body?: string;
    feature2RichText?: string;
    feature2ImageSrc: string;
    feature2ImageAltText?: string;
    feature3Eyebrow?: string;
    feature3Title?: string;
    feature3Body?: string;
    feature3RichText?: string;
    feature3ImageSrc: string;
    feature3ImageAltText?: string;
}

const UniformFeaturesHighlight = (props: UniformFeaturesHighlightProps) => {
    return (
        <FeaturesHighlight
            title={props.title}
            description={
                props.richText ? (
                    <RichTextComponent text={props.richText} />
                ) : (
                    props.description
                )
            }
            linkText={props.linkText}
            linkHref={props.linkHref}
            feature1Eyebrow={props.feature1Eyebrow}
            feature1Title={props.feature1Title}
            feature1Body={
                props.feature1RichText ? (
                    <RichTextComponent text={props.feature1RichText} />
                ) : (
                    props.feature1Body
                )
            }
            feature1ImageSrc={props.feature1ImageSrc}
            feature1ImageAltText={props.feature1ImageAltText}
            feature2Eyebrow={props.feature2Eyebrow}
            feature2Title={props.feature2Title}
            feature2Body={
                props.feature2RichText ? (
                    <RichTextComponent text={props.feature2RichText} />
                ) : (
                    props.feature2Body
                )
            }
            feature2ImageSrc={props.feature2ImageSrc}
            feature2ImageAltText={props.feature2ImageAltText}
            feature3Eyebrow={props.feature3Eyebrow}
            feature3Title={props.feature3Title}
            feature3Body={
                props.feature3RichText ? (
                    <RichTextComponent text={props.feature3RichText} />
                ) : (
                    props.feature3Body
                )
            }
            feature3ImageSrc={props.feature3ImageSrc}
            feature3ImageAltText={props.feature3ImageAltText}
        />
    );
};

export default UniformFeaturesHighlight;
